import CompanyManagementContainer from "../../../Component/Application/exhibitorsaccess/company-management-container"

const ExhibitorsAccessPage = () => {
    return (
        <div className="page-body">
            <CompanyManagementContainer />
        </div>
    );
};

export default ExhibitorsAccessPage;